













import { Component, Model, Prop, Vue } from "vue-property-decorator";

@Component
export default class Checkbox extends Vue {
  @Model("change") selected!: any[] | boolean | null | undefined;
  @Prop() value!: any;
  @Prop({ type: String }) name!: string;
  @Prop({ type: String, required: true }) text!: string;

  onChange(event: Event) {
    const newSelection = (event.target as HTMLInputElement).value;
    if (this.selected instanceof Array) {
      if (this.selected.includes(newSelection)) {
        this.$emit(
          "change",
          this.selected.filter(entry => entry !== newSelection)
        );
      } else {
        this.$emit("change", [...this.selected, newSelection]);
      }
    } else if (this.selected === null || this.selected === undefined) {
      this.$emit("change", [newSelection]);
    } else {
      this.$emit("change", (event.target as HTMLInputElement).checked);
    }
  }

  get checked() {
    if (this.selected instanceof Array) {
      return this.selected.includes(this.value);
    } else {
      return this.selected;
    }
  }
}
